(function (w, $) {
    const assetIds = ['registration2', '~/Parts/Views/User/Registration2/Registration2.min.js'];
    const ctxAssets = w.getAssetsByKeys(w.umwAssets, assetIds);

    if (!ctxAssets || !ctxAssets.length) {
        console.error('No context found for: ' + JSON.stringify(assetIds));
        return;
    }

    for (let ctx of ctxAssets) {

        const handlerUrl = w.R + 'handlers/public/UserData.ashx';
        const $mainPanel = $('#' + ctx.mainPanelID);
        let regType = ctx.initialRegType;
        const labels = ctx.labels;
        const _isNewCustomer = ctx.customer && ctx.customer.IsNewCustomer;
        const _enableFullNameMode = ctx.enableFullNameMode;
        let $сontactSection;
        let $newContactUI = null;
        let $newDelivAddressSection;
        let $newDelivAddressUI = null;
        let company = null;
        const _showDeliveryAddressSection = ctx.showDeliveryAddressSection;
        const _contactFormModeIsEnabled = ctx.contactFormModeIsEnabled;
        const _deliveryAddressUserId = ctx.company ? ctx.company.UserID : (ctx.customer ? ctx.customer.UserID : 0);
        const _shouldShowContactTagify = ctx.company && ctx.thisUserId !== 2 && ctx.compactFormModeIsEnabled === true;
        const _shouldShowDeliveryAddressTagify = ctx.thisUserId !== 2 && ctx.compactFormModeIsEnabled === true && ctx.allowMultipleDelivAddresses === true;
        const _useTabs = ctx.useTabs || false;
        let contactPersonTagifyInput = null;
        let deliveryAddressTagifyInput = null;
        let validationFailsAddressIDs = [];

        w.onload = function() {
            const registrationSuccess = sessionStorage.getItem("registrationSuccess");
            if (registrationSuccess) {
                sessionStorage.removeItem("registrationSuccess");
                w.PubSub.publish('notification.success', ctx.messages.registrationSuccess);
            }
        }

        function _processClonedHtml($clonedHtml, parentSelector) {
            // Fix unique attributes
            var targetAttr = ['id', 'for', 'name', 'data-validates-section', 'data-rule-equalto'];

            const currentIndex = $(parentSelector).length + 1;
            $clonedHtml.find('*').add($clonedHtml).each(function() {
                const $this = $(this);
                for (let i = 0; i < targetAttr.length; i++) {
                    const currentAttr = targetAttr[i];
                    const currentAttrVal = $this.attr(currentAttr);
                    if (currentAttrVal) {
                        $this.attr(currentAttr, currentAttrVal.replace(/^(.*)(\d)*$/i, '$1' + currentIndex));
                    }
                }
            });
        };

        function _copyCompanyInvoiceAddressToDeliveryAddressIfEmpty() {
            if (regType !== 'company' || ctx.allowMultipleDelivAddresses === true) {
                return;
            }

            _readCompany();

            const $delivAddressUI = $mainPanel.find('.DeliveryAddressesSectionContainer .DeliveryAddressSection');
            const $custUI = $mainPanel.find('.ContactPersonsSectionContainer .ContactPersonSection');

            let deliveryAddress = _readDeliveryAddress($delivAddressUI, $custUI);
            if (!deliveryAddress) {
                deliveryAddress = {};
            }

            let fillDeliveryAddresUI = false;
            if ((!deliveryAddress.Address && !deliveryAddress.Address2) || !deliveryAddress.PostCode || !deliveryAddress.PostArea) {
                deliveryAddress.Address = company.InvoiceAddress.Address;
                deliveryAddress.Address2 = company.InvoiceAddress.Address2;
                deliveryAddress.PostCode = company.InvoiceAddress.PostCode;
                deliveryAddress.PostArea = company.InvoiceAddress.PostArea;
                deliveryAddress.CountryCode = company.InvoiceAddress.CountryCode;

                fillDeliveryAddresUI = true;
            }

            if (!deliveryAddress.CompanyName) {
                deliveryAddress.CompanyName = company.Name;

                fillDeliveryAddresUI = true;
            }

            if (fillDeliveryAddresUI) {
                _displayDeliveryAddress($delivAddressUI, deliveryAddress);
            }
        }

        function _validateForm(successCallback) {

            let validator = null;

            if (_useTabs === true) {

                const isCompany = regType === 'company';

                validator = $mainPanel.validate({
                    ignore: function (index, el) {
                        var el = $(el);

                        if (el.parents('.ContactPersonSectionTemplate').length ||
                            el.parents('.DeliveryAddressSectionTemplate').length ||
                            el.parents('.tab-pane.hidden').length ||
                            el.parents('.tab-pane[hidden]').length ||
                            (_isNewCustomer === false && el.parents('.tab-pane:not(.hidden):not(.active)').length) ||
                            (!_isNewCustomer && el.parents('.NewCustomerOnly').length) ||
                            (isCompany && el.parents('.PrivateCustomerOnly').length) ||
                            (!isCompany && el.parents('.CompanyUserOnly').length) ||
                            el.parents('.ContactFormModeHiddenRow').length) {

                            return true;
                        }

                        // UMWC-9659: for EXISTING customers, skip validation for contact-person
                        // sections that do not belong to the current user. Hidden sections
                        // (tagify/compact mode) and sibling contacts' sections are re-posted as-is to
                        // the server but must not block the save when they have missing required fields.
                        // KHG-9900: this must NOT apply to a NEW registration, where the contact-person
                        // tab is simply inactive (not :visible) yet its required fields must still be
                        // enforced - otherwise an empty/anonymous contact is created and no registration
                        // notification is sent. The tab-error highlighting below guides the user to it.
                        if (!_isNewCustomer) {
                            var $contactSection = el.closest('.ContactPersonSection');
                            if ($contactSection.length) {
                                if (!$contactSection.is(':visible')) {
                                    return true;
                                }
                                var customerData = $contactSection.data('customer');
                                if (customerData && customerData.UserID && customerData.UserID !== ctx.thisUserId) {
                                    return true;
                                }
                            }

                            // Same treatment for delivery-address sections (tagify selector hides siblings).
                            var $deliverySection = el.closest('.DeliveryAddressSection');
                            if ($deliverySection.length && !$deliverySection.is(':visible')) {
                                return true;
                            }
                        }

                        return false;
                    }
                });
            } else {
                validator = $mainPanel.validate({ ignore: ':hidden' });
            }

            validator.resetForm();
            const isFormValid = validator.form();
            if (isFormValid) {
                if (typeof (successCallback) === 'function') {
                    successCallback.apply(this, []);
                }
                w.PubSub.publish('validation.success.registration2', validator.successList);
            } else {
                // Show default general validation error
                w.PubSub.publish('notification.error', ctx.messages.generalValidationError);
                w.PubSub.publish('validation.error.registration2', validator.errorList);
                if (_useTabs === true) {
                    //Reset and hightlight tab error state at UI
                    _clearErrorStates();
                    const navTabs = $mainPanel.find('.nav-tabs');
                    const firstFailedInput = $(validator.errorList[0].element);
                    const tabID = firstFailedInput.parents('.tab-pane').attr('id');
                    const tabSelector = navTabs.find('button').length ? 'button[data-bs-target="#' + tabID + '"]' : 'a[href="#' + tabID + '"]';
                    const theTabHyperlinkWithErrors = navTabs.find(tabSelector);
                    const theTabLiWithErrors = theTabHyperlinkWithErrors.parent('li');

                    theTabLiWithErrors.addClass('has-required-fields');
                    theTabHyperlinkWithErrors.tab('show');
                }
            }
        };

        function _showConfirmation(message, acceptCallback, cancelCallback) {
            const notyConfig = {
                layout: 'center',
                animation: {
                    open: { height: 'toggle' },
                    close: { height: 'toggle' },
                    easing: 'swing',
                    speed: 150
                },
                killer: true,
                modal: true,
                text: message,
                buttons: [
                    {
                        addClass: 'btn btn-primary btn-small',
                        text: ctx.messages.yes,
                        onClick: function(noty) {
                            if (typeof (acceptCallback) === 'function') {
                                acceptCallback.apply(this, [noty]);
                            }
                            noty.close();
                        }
                    },
                    {
                        addClass: 'btn btn-outline-danger btn-small',
                        text: ctx.messages.no,
                        onClick: function(noty) {
                            if (typeof (cancelCallback) === 'function') {
                                cancelCallback.apply(this, [noty]);
                            }
                            noty.close();
                        }
                    }
                ]
            };

            w.noty(notyConfig);
        };

        function _displayProperRegTypeFields(instantly) {
            const $companySection = $mainPanel.find('.CompanySection');
            if (regType === 'company') {
                $companySection.slideDown('fast');

                $mainPanel.find('.ContactPersonTitle').text(labels.contactPersonInfoTitle);
                $mainPanel.find('.CompanyUserOnly' +
                    (_isNewCustomer ? ':not(.ExistingCustomerOnly)' : ':not(.NewCustomerOnly)')).show();
                $mainPanel.find('.PrivateCustomerOnly').hide();
                $mainPanel.find('.DeliveryCompanyNameRow').show();

                $mainPanel.find('.DeliveryAddressesSectionContainer').show();
                $mainPanel.find('.ContactPersonDeliveryDescriptionRow').hide();

                _setTabsForCompany();
            } else if (regType === 'private') {
                if (instantly) {
                    $companySection.hide();
                } else {
                    $companySection.slideUp('fast');
                }

                $mainPanel.find('.ContactPersonTitle').text(labels.profile);
                $mainPanel.find('.PrivateCustomerOnly' +
                    (_isNewCustomer ? ':not(.ExistingCustomerOnly)' : ':not(.NewCustomerOnly)')).show();
                $mainPanel.find('.CompanyUserOnly').hide();
                $mainPanel.find('.DeliveryCompanyNameRow').hide();

                if (!_showDeliveryAddressSection) {
                    $mainPanel.find('.DeliveryAddressesSectionContainer').hide();
                    $mainPanel.find('.ContactPersonDeliveryDescriptionRow').show();
                } else {
                    $mainPanel.find('.ContactPersonDeliveryDescriptionRow').hide();
                }

                _setTabsForPrivate();
            }
        };

        function _setTabsForCompany() {
            if (_useTabs === false) {
                return;
            }

            const els = _getTabsElements();

            els.liTabCompany.removeClass('hidden').removeAttr('hidden');
            els.tabCompany.removeClass('hidden').removeAttr('hidden');

            els.liTabContact.removeClass('hidden').removeAttr('hidden');
            els.tabContact.removeClass('hidden').removeAttr('hidden');

            els.liTabDelivery.removeClass('hidden').removeAttr('hidden');
            els.tabDelivery.removeClass('hidden').removeAttr('hidden');

            const contactPersonTabName = els.tabContact.find('div[data-umw-tab-name]').data('umw-tab-name');
            if (contactPersonTabName) {
                els.liTabContact.find('[role="tab"]').text(contactPersonTabName);
            }

            if ($("body").hasClass("bs5")) {
                if (els.liTabContact.find('.nav-link').hasClass('active') || els.liTabDelivery.find('.nav-link').hasClass('active')) {
                    els.liTabContact.find('.nav-link').removeClass('active');
                    els.tabContact.removeClass('active show');

                    els.liTabDelivery.find('.nav-link').removeClass('active');
                    els.tabDelivery.removeClass('active show');

                    els.liTabCompany.find('.nav-link').addClass('active');
                    els.tabCompany.addClass('active show');
                }
            }
            else {
                if (els.liTabContact.hasClass('active') || els.liTabDelivery.hasClass('active')) {
                    els.liTabContact.removeClass('active');
                    els.tabContact.removeClass('active');

                    els.liTabDelivery.removeClass('active');
                    els.tabDelivery.removeClass('active');

                    els.liTabCompany.addClass('active');
                    els.tabCompany.addClass('active');
                }
            }

            els.liTabDelivery.click(function () {
                _copyCompanyInvoiceAddressToDeliveryAddressIfEmpty();
            });
        }

        function _setTabsForPrivate() {
            if (_useTabs === false) {
                return;
            }

            const els = _getTabsElements();

            if ($("body").hasClass("bs5")) {
                if (els.liTabCompany.find('.nav-link').hasClass('active') || (els.liTabDelivery.find('.nav-link').hasClass('active') && _showDeliveryAddressSection === false)) {

                    els.liTabCompany.find('.nav-link').removeClass('active');
                    els.tabCompany.removeClass('active show');

                    els.liTabDelivery.find('.nav-link').removeClass('active');
                    els.tabDelivery.removeClass('active show');

                    els.liTabContact.find('.nav-link').addClass('active');
                    els.tabContact.addClass('active show');
                }
            }
            else {
                if (els.liTabCompany.hasClass('active') || (els.liTabDelivery.hasClass('active') && _showDeliveryAddressSection === false)) {
                    els.liTabCompany.removeClass('active');
                    els.tabCompany.removeClass('active');

                    els.liTabDelivery.removeClass('active');
                    els.tabDelivery.removeClass('active');

                    els.liTabContact.addClass('active');
                    els.tabContact.addClass('active');
                }
            }

            els.liTabCompany.addClass('hidden').attr('hidden', true);
            els.tabCompany.addClass('hidden').attr('hidden', true);

            if (_showDeliveryAddressSection === false) {
                els.liTabDelivery.addClass('hidden').attr('hidden', true);
                els.tabDelivery.addClass('hidden').attr('hidden', true);
            }

            els.liTabContact.find('[role="tab"]').text(labels.profile);
        }

        function _getTabsElements() {
            return {
                liTabCompany: $mainPanel.find('li.js-company-tab'),
                liTabContact: $mainPanel.find('li.js-contact-tab'),
                liTabDelivery: $mainPanel.find('li.js-delivery-tab'),
                tabCompany: $mainPanel.find('div.js-company-tab'),
                tabContact: $mainPanel.find('div.js-contact-tab'),
                tabDelivery: $mainPanel.find('div.js-delivery-tab')
            };
        }

        function _detectAndHandleRedirect(response) {
            if (typeof (response) === 'string') {
                const redirectStringPrefix = 'REDIRECT:';
                if (response.indexOf(redirectStringPrefix) === 0) {
                    const redirectUrl = response.slice(redirectStringPrefix.length);
                    w.location.replace(redirectUrl);
                    return true;
                }
                w.PubSub.publish('notification.error', 'Unexpected server response.');
            }
            return false;
        }

        function _setUpPostalAreaAutoCompletion($region) {
            const relatedPostAreaInputDataKey = 'relatedPostAreaInput';

            const $postCodeInput = $region.find('.PostCodeInput');
            const $postAreaInput = $region.find('.PostAreaInput');
            const $countrySelect = $region.find('.CountrySelect, .DeliveryCountrySelect');

            const isKeyUpHandlerAlreadySetUp = $postCodeInput.data(relatedPostAreaInputDataKey);

            $postCodeInput.data(relatedPostAreaInputDataKey, $postAreaInput);

            if (isKeyUpHandlerAlreadySetUp) {
                return;
            }

            $postCodeInput.keyup(function() {
                const $postCodeInput = $(this);
                const postCodeVal = $postCodeInput.val().trim();
                if (postCodeVal && ($countrySelect.length && $countrySelect.val() == 'NO' || !$countrySelect.length && w.globalSettings.CountryCode === 'NO')) {
                    $.getPostalCodeInfo(postCodeVal,
                        function(d) {
                            const $postAreaInput = $postCodeInput.data(relatedPostAreaInputDataKey);
                            $postAreaInput.val(d.valid ? d.result : '');
                        });
                }
            });
        }

        function _setupToolTip($container) {
            const $toolTipControl = $container.find('.Tooltip');

            if ($toolTipControl) {
                $toolTipControl.tooltip();
            }
        }

        function _displayCustomer($ui, customer) {
            var $lastNameRow = $ui.find('.ContactPersonLastNameRow');
            var isLastNameShown = $lastNameRow.length > 0;

            var isFullNameMode = _enableFullNameMode &&
                (isLastNameShown || customer.ECustomerID || (customer.FirstName && !customer.LastName));
            if (isFullNameMode) {
                if (isLastNameShown) {
                    $lastNameRow.hide();
                    $ui.find('.ContactPersonLastNameInput').val('');
                }

                var $firstNameLabel = $ui.find('.ContactPersonFirstNameLabel');
                if ($firstNameLabel.length) {
                    $firstNameLabel.html($firstNameLabel.html().replace(ctx.firstNameText, labels.fullName));
                    $firstNameLabel.removeClass('ContactPersonFirstNameLabel').addClass('ContactPersonFullNameLabel');
                }
            } else {
                if (isLastNameShown) {
                    $lastNameRow.show();
                    $ui.find('.ContactPersonLastNameInput').val(customer.LastName);
                }
            }

            $ui.find('.ContactPersonFirstNameInput').val(customer.FirstName);
            $ui.find('.ContactPersonGenderOption input').val([customer.Gender]);
            $ui.find('.ContactPersonDateOfBirthInput').val(customer.DateOfBirth);
            $ui.find('.ContactPersonPhoneInput').val(customer.Phone);
            $ui.find('.ContactPersonMobilePhoneInput').val(customer.MobilePhone);
            if (customer.InvoiceAddress) {
                $ui.find('.InvoiceAddressInput').val(customer.InvoiceAddress.Address);
                $ui.find('.InvoiceAddress2Input').val(customer.InvoiceAddress.Address2);
                $ui.find('.InvoicePostCodeInput').val(customer.InvoiceAddress.PostCode);
                $ui.find('.InvoicePostAreaInput').val(customer.InvoiceAddress.PostArea);
                $ui.find('.CountrySelect').val(customer.InvoiceAddress.CountryCode);
            }
            $ui.find('.ContactPersonEmailInput').val(customer.Email);
            _setNewsletterSubscirptionStatus($ui, customer.IsNewsletterRecipient);

            if (customer.IsNewCustomer) {
                $ui.find('.NewCustomerOnly' +
                    (regType === 'company' ? ':not(.PrivateCustomerOnly)' : ':not(.CompanyUserOnly)')).show();
                $ui.find('.ExistingCustomerOnly').hide();
            } else {
                $ui.find('.ExistingCustomerOnly' +
                    (regType === 'company' ? ':not(.PrivateCustomerOnly)' : ':not(.CompanyUserOnly)')).show();
                $ui.find('.NewCustomerOnly').hide();
            }
        };

        function _readCustomer($ui) {
            const customer = $ui.data('customer');

            customer.FirstName = $ui.find('.ContactPersonFirstNameInput').val();
            customer.LastName = $ui.find('.ContactPersonLastNameInput').val();
            customer.Gender = $ui.find('.ContactPersonGenderOption input:checked').val() || null;

            customer.DateOfBirth = $ui.find('.ContactPersonDateOfBirthInput').val();
            customer.Phone = $ui.find('.ContactPersonPhoneInput').val();
            customer.MobilePhone = $ui.find('.ContactPersonMobilePhoneInput').val();
            customer.Email = $ui.find('.ContactPersonEmailInput').val();
            customer.IsNewsletterRecipient = _getNewsletterSubscirptionStatus($ui);

            if (regType === 'private') {
                customer.InvoiceAddress = {
                    Address: $ui.find('.InvoiceAddressInput').val(),
                    Address2: $ui.find('.InvoiceAddress2Input').val(),
                    PostCode: ($ui.find('.InvoicePostCodeInput').val() || '').trim(),
                    PostArea: $ui.find('.InvoicePostAreaInput').val(),
                    CountryCode: $ui.find('.CountrySelect').val()
                };
            }

            return customer;
        };

        function _createCustomerUI() {
            const $tmp = $сontactSection.clone(true);
            _processClonedHtml($tmp, '.ContactPersonSection');
            $tmp.removeClass('ContactPersonSectionTemplate').addClass('ContactPersonSection');
            _setUpPostalAreaAutoCompletion($tmp);

            const $dateTimePicker = $tmp.find('.ContactPersonDateOfBirthInput');
            $dateTimePicker.datepicker({ onClose: function() { $(this).blur(); } });

            $tmp.insertBefore($сontactSection);
            $tmp.show();
            return $tmp;
        };

        function _onNewContactEditFinished(cancelled) {
            $mainPanel.find('.ButtonCanceladdcontact').hide();
            $mainPanel.find('.ButtonAddcontact').show();

            if (cancelled) {
                $newContactUI.remove();
                _updateContactTagifyWhitelist(ctx.thisUserId);
            }
            $newContactUI = null;
        };

        function _displayCompany() {
            const $ui = $mainPanel.find('.CompanySection');
            if (!$ui.length) {
                return;
            }

            if (_isNewCustomer) {
                $ui.find('.ExistingCustomerOnly').hide();
            } else {
                $ui.find('.NewCustomerOnly').hide();
            }

            if (!company) {
                return;
            }

            $ui.find('.CompanyInput').val(company.Name);
            $ui.find('.CompanyNoInput').val(company.CompanyNumber);
            $ui.find('.CompanyPhoneInput').val(company.Phone);

            $ui.find('.InvoiceContactInput').val(company.ContactPersonName);
            $ui.find('.InvoiceAddressInput').val(company.InvoiceAddress.Address);
            $ui.find('.InvoiceAddress2Input').val(company.InvoiceAddress.Address2);
            $ui.find('.InvoicePostCodeInput').val(company.InvoiceAddress.PostCode);
            $ui.find('.InvoicePostAreaInput').val(company.InvoiceAddress.PostArea);
            $ui.find('.CountrySelect').val(company.InvoiceAddress.CountryCode);
            $ui.find('.InvoiceEmailInput').val(company.ContactPersonEmail);
            _setNewsletterSubscirptionStatus($ui, company.IsNewsletterRecipient);
        }

        function _readCompany() {
            const $ui = $mainPanel.find('.CompanySection');
            if (!$ui.length) {
                return;
            }

            if (!company)
                company = {};
            if (!company.InvoiceAddress)
                company.InvoiceAddress = {};

            company.Name = $ui.find('.CompanyInput').val();
            company.CompanyNumber = $ui.find('.CompanyNoInput').val();
            company.Phone = $ui.find('.CompanyPhoneInput').val();

            company.ContactPersonName = $ui.find('.InvoiceContactInput').val();
            company.InvoiceAddress.Address = $ui.find('.InvoiceAddressInput').val();
            company.InvoiceAddress.Address2 = $ui.find('.InvoiceAddress2Input').val();
            company.InvoiceAddress.PostCode = ($ui.find('.InvoicePostCodeInput').val() || '').trim();
            company.InvoiceAddress.PostArea = $ui.find('.InvoicePostAreaInput').val();
            company.InvoiceAddress.CountryCode = $ui.find('.CountrySelect').val();
            company.ContactPersonEmail = $ui.find('.InvoiceEmailInput').val();
            company.IsNewsletterRecipient = _getNewsletterSubscirptionStatus($ui);
        };

        function _createDeliveryAddressUI() {
            const $tmp = $newDelivAddressSection.clone(true);
            _processClonedHtml($tmp, '.DeliveryAddressSection');
            $tmp.removeClass('DeliveryAddressSectionTemplate').addClass('DeliveryAddressSection');
            _setUpPostalAreaAutoCompletion($tmp);
            _setupToolTip($tmp);

            $tmp.insertBefore($newDelivAddressSection);
            $tmp.show();
            return $tmp;
        };

        function _displayDeliveryAddress($ui, deliveryAddress) {
            $ui.find('.DeliveryFirstNameInput').val(deliveryAddress.FirstName);
            $ui.find('.DeliveryLastNameInput').val(deliveryAddress.LastName);
            $ui.find('.DeliveryPhoneInput').val(deliveryAddress.Phone);
            $ui.find('.DeliveryEmailInput').val(deliveryAddress.EMail);
            $ui.find('.DeliveryAddressInput').val(deliveryAddress.Address);
            $ui.find('.DeliveryAddress2Input').val(deliveryAddress.Address2);
            $ui.find('.DeliveryPostCodeInput').val(deliveryAddress.PostCode);
            $ui.find('.DeliveryPostAreaInput').val(deliveryAddress.PostArea);
            $ui.find('.DeliveryCountrySelect').val(deliveryAddress.CountryCode);
            $ui.find('.DeliveryCompanyInput').val(deliveryAddress.CompanyName);
            $ui.find('.DeliveryDescriptionInput').val(deliveryAddress.Description);

            _displayDeliveryAddressDefaultFlag($ui, deliveryAddress.IsDefault);
        }

        function _displayNewDeliveryAddressDefaultFlag(newDefaultDeliveryAddressId) {
            const $deliveryAddressSections = $mainPanel.find('.DeliveryAddressesSectionContainer .DeliveryAddressSection');
            $deliveryAddressSections.each(function(index, deliveryAddressSection) {
                const $addressUI = $(deliveryAddressSection);
                const address = $addressUI.data('deliveryAddress');
                if (address) {
                    _displayDeliveryAddressDefaultFlag($addressUI, address.ID === newDefaultDeliveryAddressId);
                }
            });
        }

        function _displayDeliveryAddressDefaultFlag($ui, isDefault) {
            const $btnIsDef = $ui.find('.ButtonDefaultDeliveryAddress');
            if (isDefault)
                $btnIsDef.addClass('btn-primary');
            else
                $btnIsDef.removeClass('btn-primary');
        }

        function _displayDeliveryAddressDescriptionForPrivateUser($ui, deliveryAddresses) {
            if (deliveryAddresses && deliveryAddresses.length) {
                const defaultDeliveryAddresses = _.filter(deliveryAddresses,
                    function(deliveryAddress) {
                        return deliveryAddress.IsDefault;
                    });

                if (defaultDeliveryAddresses && defaultDeliveryAddresses.length === 1) {
                    const address = defaultDeliveryAddresses[0];
                    const $deliveryDescriptionInput = $ui.find('.ContactPersonDeliveryDescriptionInput');
                    $deliveryDescriptionInput.val(address.Description);
                    $deliveryDescriptionInput.data('deliveryAddressID', address.ID);
                }
            }
        }

        function _readDeliveryAddress($delivAddressUI, $custUI) {
            let address = null;

            if ($custUI && $custUI.length && regType === 'private' && !_showDeliveryAddressSection) {
                address = _readDeliveryAddressForPrivateUser($custUI);
            } else if ($delivAddressUI && $delivAddressUI.length) {
                address = $delivAddressUI.data('deliveryAddress');
                address.FirstName = $delivAddressUI.find('.DeliveryFirstNameInput').val();
                address.LastName = $delivAddressUI.find('.DeliveryLastNameInput').val();
                address.Phone = $delivAddressUI.find('.DeliveryPhoneInput').val();
                address.EMail = $delivAddressUI.find('.DeliveryEmailInput').val();
                address.Address = $delivAddressUI.find('.DeliveryAddressInput').val();
                address.Address2 = $delivAddressUI.find('.DeliveryAddress2Input').val();
                address.PostCode = ($delivAddressUI.find('.DeliveryPostCodeInput').val() || '').trim();
                address.PostArea = $delivAddressUI.find('.DeliveryPostAreaInput').val();
                address.CountryCode = $delivAddressUI.find('.DeliveryCountrySelect').val();
                address.CompanyName = $delivAddressUI.find('.DeliveryCompanyInput').val();
                address.Description = $delivAddressUI.find('.DeliveryDescriptionInput').val();
                address.IsDefault = ctx.allowMultipleDelivAddresses
                    ? $delivAddressUI.find('.ButtonDefaultDeliveryAddress').hasClass('btn-primary')
                    : true;
            }

            return address;
        };

        function _readDeliveryAddressForPrivateUser($custUI) {
            const address = {};
            address.FirstName = $custUI.find('.ContactPersonFirstNameInput').val();
            address.LastName = $custUI.find('.ContactPersonLastNameInput').val();
            address.Phone = $custUI.find('.ContactPersonPhoneInput').val();
            address.EMail = $custUI.find('.ContactPersonEmailInput').val();
            address.Address = $custUI.find('.InvoiceAddressInput').val();
            address.Address2 = $custUI.find('.InvoiceAddress2Input').val();
            address.PostCode = ($custUI.find('.InvoicePostCodeInput').val() || '').trim();
            address.PostArea = $custUI.find('.InvoicePostAreaInput').val();
            address.CountryCode = $custUI.find('.DeliveryCountrySelect').val();
            address.IsDefault = true;

            const $deliveryDescriptionUI = $custUI.find('.ContactPersonDeliveryDescriptionInput');
            address.Description = $deliveryDescriptionUI.val();
            address.ID = $deliveryDescriptionUI.data('deliveryAddressID');

            return address;
        }

        function _onNewDelivAddressEditFinished(cancelled) {
            $mainPanel.find('.ButtonCanceladddelivaddress').hide();
            $mainPanel.find('.ButtonAdddeliveryaddress').show();

            if (cancelled) {
                $newDelivAddressUI.remove();
                _updateDeliveryAddressesTagifyWhitelist(_getDefaultOrFirstDeliveryAddressId());
            }
            $newDelivAddressUI = null;
        }

        function _redirectToReturnUrlIfPresent(redirectUrl) {
            let isBeingRedirect = false;

            if (redirectUrl) {
                w.location.replace(redirectUrl);
                isBeingRedirect = true;
            }

            return isBeingRedirect;
        }

        function _setupShowNewsletterFlags() {
            if (!ctx.shouldShowNewsletterFlag) {
                $mainPanel.find('.js-company-newsletter-row').hide();
                $mainPanel.find('.js-contact-newsletter-row').hide();
            }
        }

        function _setupDateOfBirthValidator() {
            $.validator.addMethod(
                "dateOfBirthMin1890",
                function(value, element) {
                    const inst = $.datepicker._getInst(element);
                    const dateFormat = $.datepicker._get(inst, 'dateFormat');
                    try {
                        const date = $.datepicker.parseDate(dateFormat, value, $.datepicker._getFormatConfig(inst));
                        return date >= new Date(1890, 0, 1);
                    } catch (e) {
                        return false;
                    }
                },
                ctx.messages.dateOfBirthValidationError
            );
        }

        function _setupRegistrationType() {
            _displayProperRegTypeFields(true);

            const $rbtns = $mainPanel.find('.RegistrationTypeOption input:radio');

            $rbtns.change(function() {
                regType = $rbtns.filter(':checked').val();
                _displayProperRegTypeFields();
                _setupContactFormMode();
            });
        };

        function _setupCompanySection() {
            company = ctx.company;

            _displayCompany();

            const $ui = $mainPanel.find('.CompanySection');
            if ($ui.length) {
                _setUpPostalAreaAutoCompletion($ui);
            }
        };

        function _setupContactAndDeliveryAddressTagify() {
            const $contactCont = $mainPanel.find('.ContactPersonsSectionContainer');
            const $contactPersonInput = $contactCont.find('.ContactPersonInput');

            if ($contactPersonInput) {
                if (_shouldShowContactTagify) {
                    contactPersonTagifyInput = new w.Tagify($contactPersonInput[0],
                        {
                            mode: 'select',
                            dropdown: {
                                maxItems: 100,
                                highlightFirst: true,
                                searchKeys: ['FirstName', 'LastName', 'Email']
                            },
                            templates: {
                                dropdownItem: function (tagData) {
                                    return tagData.IsNewCustomer === true && !tagData.UserID
                                        ? `<div class='tagify__dropdown__item'>
                                            <span>${labels.newContact}</span>
                                        </div>`
                                        : `<div class='tagify__dropdown__item'>
                                            <span>${tagData.FirstName} ${tagData.LastName} - ${tagData.Email
                                        }</span>
                                        </div>`;
                                },
                            },
                        });

                    contactPersonTagifyInput.on('change',
                        function (evt) {
                            if (!evt || !evt.detail || !evt.detail.value) {
                                console.warn(
                                    'Contacts tagify selector: Did not find data in the event at evt.detail.value');
                                return;
                            }

                            const selectedContacts = JSON.parse(evt.detail.value);
                            const selectedContactUserId = selectedContacts[0].UserID;

                            _setVisibleContactContainer(selectedContactUserId);
                        });

                    _updateContactTagifyWhitelist(ctx.thisUserId);
                } else {
                    $contactPersonInput.parent().hide();
                }
            }

            if (_shouldShowDeliveryAddressTagify) {

                const $addressesCont = $mainPanel.find('.DeliveryAddressesSectionContainer');
                const $addressesInput = $addressesCont.find('.DeliveryAddressesInput');

                if ($addressesInput) {

                    deliveryAddressTagifyInput = new w.Tagify($addressesInput[0],
                        {
                            mode: 'select',
                            dropdown: {
                                maxItems: 300,
                                highlightFirst: true,
                                searchKeys: [
                                    'CompanyName', 'FirstName', 'LastName', 'Address', 'Address2', 'PostCode', 'PostArea', 'Description'
                                ]
                            },
                            templates: {
                                dropdownItem: function(tagData) {
                                    return `<div class='tagify__dropdown__item' ${validationFailsAddressIDs.includes(tagData.ID) ? 'has-errors' : 'no-errors'}'>
                                                <span>
                                                    ${!tagData.ID ? labels.newDeliveryAddress : _getDeliveryAddressSummary(tagData) }
                                                    ${validationFailsAddressIDs.includes(tagData.ID) ? '<i class="un un-exclamation-triangle"></i>' : ''}
                                                </span>
                                            </div>`;
                                },
                            },
                        });

                    deliveryAddressTagifyInput.on('change',
                        function (evt) {
                            if (!evt || !evt.detail || !evt.detail.value) {
                                console.warn(
                                    'Delivery addresses tagify selector: Did not find data in the event at evt.detail.value');
                                return;
                            }

                            const selectedAddresses = JSON.parse(evt.detail.value);
                            const selectedAddressID = selectedAddresses[0].ID;

                            _setVisibleDeliveryAddressContainer(selectedAddressID);
                        });

                    _updateDeliveryAddressesTagifyWhitelist(_getDefaultOrFirstDeliveryAddressId());
                }

                w.PubSub.subscribe('validation.error.registration2', function(ignore, errorList) {
                    const uniqueErrorAddressIDs = new Set();
                    const deliveryAddresses = _getDeliveryAddressesFromContainers();

                    errorList.forEach(error => {
                        const deliveryAddressSection = error.element.closest('.DeliveryAddressSection');
                        if(deliveryAddressSection){
                            const addresses = _readDeliveryAddress($(deliveryAddressSection));
                            uniqueErrorAddressIDs.add(addresses.ID);
                        }
                    });
                    validationFailsAddressIDs = Array.from(uniqueErrorAddressIDs);

                    const firstErrorAddressID = validationFailsAddressIDs.length > 0 ? validationFailsAddressIDs[0] : null;
                    if (firstErrorAddressID) {
                        const firstErrorAddress = deliveryAddresses.find(address => address.ID === firstErrorAddressID);
                        if (firstErrorAddress) {
                            deliveryAddressTagifyInput.removeAllTags();
                            deliveryAddressTagifyInput.addTags([firstErrorAddress]);
                        }
                    }
                });
            }
        }

        function _getContactsFromContainers() {
            const $cont = $mainPanel.find('.ContactPersonsSectionContainer');
            const $contactConts = $cont.find('.ContactPersonSection');

            if (!$contactConts || $contactConts.length <= 0) {
                return null;
            }

            const contacts = [];

            $contactConts.each((_, contactCont) => {
                const contact = $(contactCont).data('customer');
                contacts.push(contact);
            });

            return contacts;
        }

        function _getContactsFromContainersWithTagifyWhitelistValue() {
            const contacts = _getContactsFromContainers();

            if (!contacts) {
                return null;
            }

            contacts.forEach(contact => {
                if (contact.IsNewCustomer === true && !contact.UserID) {
                    contact['value'] = labels.newContact;
                } else {
                    contact['value'] = `${contact.FirstName} ${contact.LastName} - ${contact.Email}`;
                }
            });

            return contacts;
        }
        
        function _findPreSelectContactById(contacts, preselectContactId) {
            if (!contacts) {
                return null;
            }

            let preselectContact = null;

            contacts.forEach(contact => {
                if (!isNaN(preselectContactId) &&
                    (preselectContactId === 0 && contact.IsNewCustomer === true)
                    || contact.UserID === preselectContactId) {

                    preselectContact = contact;
                }
            });

            return preselectContact;
        }

        function _updateContactTagifyWhitelist(preselectContactId) {

            if (_shouldShowContactTagify === false) {
                return;
            }

            const contacts = _getContactsFromContainersWithTagifyWhitelistValue();

            if (contacts && contacts.length > 0) {
                $mainPanel.find('.ContactPersonSelector').show();
                $mainPanel.find('.js-no-contacts').addClass('hidden').attr('hidden', true);
                contactPersonTagifyInput.settings.whitelist = contacts;

                let preselectContact = _findPreSelectContactById(contacts, preselectContactId);
                if (preselectContact) {
                    contactPersonTagifyInput.removeAllTags();
                    contactPersonTagifyInput.addTags([preselectContact]);
                }
            } else {
                $mainPanel.find('.ContactPersonSelector').hide();
                $mainPanel.find('.js-no-contacts').removeClass('hidden').removeAttr('hidden');
            }
        }

        function _setVisibleContactContainer(contactUserId) {
            if (isNaN(contactUserId) || contactUserId < 0) {
                return;
            }

            const $contactCont = $mainPanel.find('.ContactPersonsSectionContainer');
            const $contactConts = $contactCont.find('.ContactPersonSection');
            const $selectContactCont = $($contactConts.get().find((c) => $(c).data('customer').UserID === contactUserId));

            if ($selectContactCont) {
                $contactConts.hide();
                $selectContactCont.show();
            }
            else {
                console.warn(`Contact container matching user Id ${contactUserId} was not found.`);
            }
        }

        function _getDeliveryAddressSummary(address) {
            const name = (address.CompanyName ? address.CompanyName : `${address.FirstName} ${address.LastName}`).trim();

            const elements = [];

            if (name && name.length > 0) {
                elements.push(name);
            }

            const addr = address.Address;
            if (addr && addr.trim().length > 0) {
                elements.push(addr.trim());
            }

            const post = address.PostCode + ' ' + address.PostArea;
            if (post && post.trim().length > 0) {
                elements.push(post.trim());
            }

            return elements.join(', ');
        }

        function _getDeliveryAddressesFromContainers() {
            const $cont = $mainPanel.find('.DeliveryAddressesSectionContainer');
            const $addressConts = $cont.find('.DeliveryAddressSection');

            if (!$addressConts || $addressConts.length <= 0) {
                return null;
            }

            const deliveryAddresses = [];

            $addressConts.each((_, deliveryAddressCont) => {
                const deliveryAddress = $(deliveryAddressCont).data('deliveryAddress');
                deliveryAddresses.push(deliveryAddress);
            });

            return deliveryAddresses;
        }

        function _getDefaultOrFirstDeliveryAddressId() {
            const deliveryAddresses = _getDeliveryAddressesFromContainers();

            if (!deliveryAddresses || deliveryAddresses.length <= 0) {
                return null;
            }

            return (deliveryAddresses.find(a => a.IsDefault) || deliveryAddresses[0]).ID;
        }

        function _setVisibleDeliveryAddressContainer(deliveryAddressId) {
            if (isNaN(deliveryAddressId) || deliveryAddressId < 0) {
                return;
            }

            const $addressesCont = $mainPanel.find('.DeliveryAddressesSectionContainer');
            const $addressConts = $addressesCont.find('.DeliveryAddressSection');
            const $selectAddressCont = $($addressConts.get().find((d) => $(d).data('deliveryAddress').ID === deliveryAddressId));

            if ($selectAddressCont) {
                $addressConts.hide();
                $selectAddressCont.show();
            }
            else {
                console.warn(`Delivery address container matching Id ${deliveryAddressId} was not found.`);
            }
        }

        function _getDeliveryAddressesFromContainersWithTagifyWhitelistValue() {
            const deliveryAddresses = _getDeliveryAddressesFromContainers();

            if (!deliveryAddresses) {
                return null;
            }

            deliveryAddresses.forEach(deliveryAddress => {
                if (!deliveryAddress.ID) {
                    deliveryAddress['value'] = labels.newDeliveryAddress;
                } else {
                    let addressValue = _getDeliveryAddressSummary(deliveryAddress);
                    if ((!addressValue || !addressValue.length) && deliveryAddress.IsDefault === true) {
                        addressValue = labels.defaultDeliveryAddress;
                    }

                    deliveryAddress['value'] = addressValue;
                }
            });

            return deliveryAddresses.filter(d => d.value);
        }

        function _findPreSelectDeliveryAddressById(deliveryAddresses, preselectDeliveryAddressId) {
            if (!deliveryAddresses || isNaN(preselectDeliveryAddressId)) {
                return null;
            }

            let preselectDeliveryAddress = null;

            deliveryAddresses.forEach(address => {
                if ((preselectDeliveryAddressId === 0 && address.ID === 0)
                    || address.ID === preselectDeliveryAddressId) {

                    preselectDeliveryAddress = address;
                }
            });

            return preselectDeliveryAddress;
        }

        function _updateDeliveryAddressesTagifyWhitelist(preselectDeliveryAddressId) {

            if (_shouldShowDeliveryAddressTagify === false) {
                return;
            }

            const deliveryAddresses = _getDeliveryAddressesFromContainersWithTagifyWhitelistValue();

            if (deliveryAddresses && deliveryAddresses.length > 0) {
                deliveryAddressTagifyInput.settings.whitelist = deliveryAddresses;

                let preselectDeliveryAddress = _findPreSelectDeliveryAddressById(deliveryAddresses, preselectDeliveryAddressId);
                if (preselectDeliveryAddress) {
                    deliveryAddressTagifyInput.removeAllTags();
                    deliveryAddressTagifyInput.addTags([preselectDeliveryAddress]);
                }
            }
        }

        function _setupCustomerSection() {
            $mainPanel.find('.ButtonDeletecustomer').click(function(evt) {
                evt.preventDefault();

                const $custUI = $(this).closest('.ContactPersonSection');

                _showConfirmation(ctx.messages.confirmDeleteContact,
                    function() {
                        const cust = $custUI.data('customer');

                        $.blockUI({ message: null });
                        $.ajax({
                                url: handlerUrl,
                                method: 'POST',
                                data: { action: 'DeleteContact', Users: '[' + cust.UserID + ']' }
                            })
                            .always(function() {
                                $.unblockUI();
                            })
                            .done(function(result) {
                                if (_detectAndHandleRedirect(result)) {
                                    return;
                                }

                                $custUI.remove();

                                if (_shouldShowContactTagify) {
                                    _updateContactTagifyWhitelist(ctx.thisUserId);
                                }

                                w.PubSub.publish('notification.success', ctx.messages.deletedSuccessfully);
                            })
                            .fail(function(jqXHR, textStatus) {
                                if (typeof (jqXHR.responseJSON) === 'object' && jqXHR.responseJSON.Message) {
                                    w.PubSub.publish('notification.error', jqXHR.responseJSON.Message);
                                } else {
                                    w.PubSub.publish('notification.error', textStatus);
                                }
                            });
                    });
            });
            $mainPanel.find('.ButtonResetpassword').click(function(evt) {
                evt.preventDefault();

                const $custUI = $(this).closest('.ContactPersonSection');

                _showConfirmation(ctx.messages.confirmResetPassword,
                    function() {
                        const cust = $custUI.data('customer');

                        $.blockUI({ message: null });
                        $.ajax({
                                url: handlerUrl,
                                method: 'POST',
                                data: { action: 'ResetPassword', UserID: cust.UserID }
                            })
                            .always(function() {
                                $.unblockUI();
                            })
                            .done(function(result) {
                                if (_detectAndHandleRedirect(result)) {
                                    return;
                                }
                                w.PubSub.publish('notification.success', ctx.messages.newPasswordEmailSent);
                            })
                            .fail(function(jqXHR, textStatus) {
                                if (typeof (jqXHR.responseJSON) === 'object' && jqXHR.responseJSON.Message) {
                                    w.PubSub.publish('notification.error', jqXHR.responseJSON.Message);
                                } else {
                                    w.PubSub.publish('notification.error', textStatus);
                                }
                            });
                    });
            });
            $mainPanel.find('.ButtonAddcontact').click(function(evt) {
                evt.preventDefault();

                $newContactUI = _createCustomerUI();
                const newContact = {
                    FirstName: '',
                    LastName: '',
                    Gender: '',
                    DateOfBirth: '',
                    Phone: '',
                    MobilePhone: '',
                    Email: '',
                    DeliveryAddresses: [],
                    IsNewCustomer: true
                };
                $newContactUI.data('customer', newContact);

                // If compact mode, hide other contacts
                if (_shouldShowContactTagify) {
                    const $contactConts = $newContactUI.parent().find('.ContactPersonSection').not($newContactUI);
                    $contactConts.hide();
                    $newContactUI.show();
                    _updateContactTagifyWhitelist(0);
                }

                _displayCustomer($newContactUI, newContact);

                $(this).hide();
                $mainPanel.find('.ButtonCanceladdcontact').show();
            });
            $mainPanel.find('.ButtonCanceladdcontact').click(function(evt) {
                evt.preventDefault();

                _onNewContactEditFinished(true);
            });

            const $cont = $mainPanel.find('.ContactPersonsSectionContainer');

            // Hide ContactPersonSection as blank
            $сontactSection = $cont.find('.ContactPersonSectionTemplate');
            $сontactSection.hide();
            const $dateTimePicker = $сontactSection.find('.ContactPersonDateOfBirthInput');
            $dateTimePicker.removeAttr('id');
            $dateTimePicker.removeClass('dateselector hasDatepicker');

            if (ctx.customer) {
                const customer = ctx.customer;
                const $customerUi = _createCustomerUI();
                $сontactSection.find('.PersonalData').remove(); // remove personal data section to not be displayed for other contacts

                $customerUi.data('customer', customer);

                _displayCustomer($customerUi, customer);
                _displayDeliveryAddressDescriptionForPrivateUser($customerUi, ctx.deliveryAddresses);
            }

            if (ctx.contacts) {
                const loggedInContact = ctx.contacts.find((c) => c.UserID === ctx.thisUserId);

                if (loggedInContact) {
                    const cust = loggedInContact;
                    const $contactUi = _createCustomerUI();
                    $сontactSection.find('.PersonalData').remove();
                    $contactUi.data('customer', cust);
                    _displayCustomer($contactUi, cust);
                }

                for (let i = 0; i < ctx.contacts.length; i++) {
                    const cust = ctx.contacts[i];
                    if (!loggedInContact || cust !== loggedInContact) {
                        const $contactUi = _createCustomerUI();
                        $contactUi.data('customer', cust);
                        $contactUi.find('.ButtonDeletecustomer').removeClass("hidden");
                        _displayCustomer($contactUi, cust);

                        if (_shouldShowContactTagify) {
                            if (!loggedInContact && i === 0) {
                                $contactUi.show();
                            } else {
                                $contactUi.hide();
                            }
                        }
                    }
                }
            }
        }

        function _setupDeliveryAddressesSection() {
            $mainPanel.find('.ButtonAdddeliveryaddress').click(function(evt) {
                evt.preventDefault();

                $newDelivAddressUI = _createDeliveryAddressUI();
                const newAddress = { ID: 0, Address: '', PostCode: '', PostArea: '', CountryCode: 'NO' };
                newAddress.UserID = _deliveryAddressUserId;
                $newDelivAddressUI.data('deliveryAddress', newAddress);
                _displayDeliveryAddress($newDelivAddressUI, newAddress);

                // If compact mode, hide other delivery addresses
                if (_shouldShowDeliveryAddressTagify === true) {
                    const $addressesConts = $newDelivAddressUI.parent().find('.DeliveryAddressSection');
                    $addressesConts.hide();
                    $newDelivAddressUI.show();
                    _updateDeliveryAddressesTagifyWhitelist(0);
                }

                $(this).hide();
                $mainPanel.find('.ButtonCanceladddelivaddress').show();
            });
            $mainPanel.find('.ButtonCanceladddelivaddress').click(function(evt) {
                evt.preventDefault();

                _onNewDelivAddressEditFinished(true);
            });
            $mainPanel.find('.ButtonDeletedeliveryaddress').click(function(evt) {
                evt.preventDefault();

                const $ui = $(this).closest('.DeliveryAddressSection');
                const address = $ui.data('deliveryAddress');

                _showConfirmation(ctx.messages.confirmDeleteDelivAddress,
                    function() {
                        $.blockUI({ message: null });
                        $.ajax({
                                url: handlerUrl,
                                method: 'POST',
                                data: {
                                    action: 'DeleteDeliveryAddress',
                                    customer: { DeliveryAddress: { ID: address.ID, UserID: address.UserID } }
                                }
                            })
                            .always($.unblockUI)
                            .done(function(result) {
                                if (_detectAndHandleRedirect(result)) {
                                    return;
                                }

                                $ui.remove();

                                if (_shouldShowDeliveryAddressTagify) {
                                    _updateDeliveryAddressesTagifyWhitelist(_getDefaultOrFirstDeliveryAddressId());
                                }

                                w.PubSub.publish('notification.success', ctx.messages.deletedSuccessfully);
                                _displayNewDeliveryAddressDefaultFlag(result.defaultAddressId);
                            })
                            .fail(function(jqXHR, textStatus) {
                                if (typeof (jqXHR.responseJSON) === 'object' && jqXHR.responseJSON.Message) {
                                    w.PubSub.publish('notification.error', jqXHR.responseJSON.Message);
                                } else {
                                    w.PubSub.publish('notification.error', textStatus);
                                }
                            });
                    });
            });
            $mainPanel.find('.ButtonDefaultDeliveryAddress').click(function(evt) {
                evt.preventDefault();

                const $ui = $(this).closest('.DeliveryAddressSection');
                const address = $ui.data('deliveryAddress');

                $.blockUI({ message: null });
                $.ajax({
                        url: handlerUrl,
                        method: 'POST',
                        data: {
                            action: 'SetDefaultDeliveryAddress',
                            customer: { DeliveryAddress: { ID: address.ID, UserID: address.UserID } }
                        }
                    })
                    .always($.unblockUI)
                    .done(function(result) {
                        if (_detectAndHandleRedirect(result)) {
                            return;
                        }
                        _displayNewDeliveryAddressDefaultFlag(address.ID);
                    })
                    .fail(function(jqXHR, textStatus) {
                        if (typeof (jqXHR.responseJSON) === 'object' && jqXHR.responseJSON.Message) {
                            w.PubSub.publish('notification.error', jqXHR.responseJSON.Message);
                        } else {
                            w.PubSub.publish('notification.error', textStatus);
                        }
                    });
            });

            function firstTimeShowDeliveryAddresses(addresses) {
                const defaultOrFirstId = (addresses.find(a => a.IsDefault) || addresses[0]).ID;

                for (let i = 0; i < addresses.length; i++) {
                    const address = addresses[i];
                    address.UserID = _deliveryAddressUserId;
                    const $ui = _createDeliveryAddressUI();
                    $ui.data('deliveryAddress', address);
                    if (!_isNewCustomer) {
                        $ui.find('.ButtonDeletedeliveryaddress').show();
                        $ui.find('.ButtonDefaultDeliveryAddress').show();
                    }
                    _displayDeliveryAddress($ui, address);

                    if (_shouldShowDeliveryAddressTagify) {
                        if (address.ID === defaultOrFirstId) {
                            $ui.show();
                        } else {
                            $ui.hide();
                        }
                    }
                }
            }

            const $ui = $mainPanel.find('.DeliveryAddressesSectionContainer .DeliveryAddressSectionTemplate');
            $newDelivAddressSection = $ui;
            $newDelivAddressSection.hide();

            if (ctx.deliveryAddresses)
                firstTimeShowDeliveryAddresses(ctx.deliveryAddresses);
        }

        function _setupRegisterButton() {
            $mainPanel.find('.ButtonRegisternewcustomer').click(function(evt) {
                evt.preventDefault();

                _copyCompanyInvoiceAddressToDeliveryAddressIfEmpty();

                _validateForm(function() {
                    if (!_isNewCustomer) {
                        return;
                    }

                    let comp = null;
                    if (regType === 'company') {
                        _readCompany();
                        comp = company;
                    }
                    const $custUI = $mainPanel.find('.ContactPersonsSectionContainer .ContactPersonSection');
                    const cust = _readCustomer($custUI);
                    cust.password = $custUI.find('.ContactPersonPasswordInput').val();

                    const $delivAddressUI = $mainPanel.find('.DeliveryAddressesSectionContainer .DeliveryAddressSection');
                    cust.DeliveryAddress = _readDeliveryAddress($delivAddressUI, $custUI);

                    $.blockUI({ message: null });
                    if (_contactFormModeIsEnabled) {
                        $.ajax({
                                url: handlerUrl,
                                method: 'POST',
                                data: {
                                    action: 'SendUserRegistrationNotification',
                                    regtype: regType,
                                    company: comp,
                                    customer: cust
                                }
                            })
                            .done(function() {
                                w.PubSub.publish('notification.success',
                                    {
                                        text: labels['userRegistrationRequestHasBeenSuccessfullySent'],
                                        timeout: 0,
                                        killer: true
                                    });
                            })
                            .fail(failCallback)
                            .always($.unblockUI);
                    } else {
                        $.ajax({
                                url: handlerUrl,
                                method: 'POST',
                                data: { action: 'RegisterNewCustomer', regtype: regType, company: comp, customer: cust }
                            })
                            .done(function(result) {
                                let redirectUrl = result.redirectUrl || ctx.returnURL;
                                const pendingApprovalStatus = 1;

                                if (redirectUrl && result.customer.RegistrationStatus === pendingApprovalStatus) {
                                    const registrationRequestSentMsgId = 80067;
                                    redirectUrl = $.setQueryStringParam(redirectUrl,
                                        'infowarnmsgid',
                                        registrationRequestSentMsgId);
                                }

                                if (_redirectToReturnUrlIfPresent(redirectUrl)) {
                                    return;
                                }

                                if (result.customer.RegistrationStatus === pendingApprovalStatus) {
                                    w.PubSub.publish('notification.warning',
                                        { text: ctx.messages.registrationRequestSent, timeout: 0, killer: true });
                                } else {
                                    sessionStorage.setItem('registrationSuccess', 'true');
                                    w.location.reload(true);
                                }
                            })
                            .fail(failCallback)
                            .always($.unblockUI);
                    }

                    function failCallback(jqXHR, textStatus) {
                        if (typeof (jqXHR.responseJSON) === 'object' && jqXHR.responseJSON.Message) {
                            w.PubSub.publish('notification.error', jqXHR.responseJSON.Message);
                        } else {
                            w.PubSub.publish('notification.error', textStatus);
                        }
                    }
                });
            });
        };

        function _setupSaveButton() {
            $mainPanel.find('.ButtonSave').click(function(evt) {
                evt.preventDefault();

                _validateForm(function() {
                    _readCompany();

                    var customers = [];
                    var $customerSections = $mainPanel.find('.ContactPersonSection');
                    var isCustomerAdded = false;
                    var deliveryAddresses = [];

                    $customerSections.each(function(index, customerSection) {
                        const $customerUI = $(customerSection);
                        const customer = _readCustomer($customerUI);
                        if (regType === 'private' && !_showDeliveryAddressSection) {
                            const address = _readDeliveryAddressForPrivateUser($customerUI);
                            deliveryAddresses.push({ DeliveryAddress: address });
                        }

                        if (!customer.UserID) {
                            isCustomerAdded = true;
                            customer.password = $customerUI.find('.ContactPersonPasswordInput').val();
                        }

                        if (company) {
                            customer.CompanyUserID = company.UserID;
                        }
                        customers.push(customer);
                    });

                    const $deliveryAddressSections = $mainPanel.find('.DeliveryAddressesSectionContainer .DeliveryAddressSection');
                    let isAddressAdded = false;
                    $deliveryAddressSections.each(function(index, deliveryAddressSection) {
                        const $addressUI = $(deliveryAddressSection);
                        const address = _readDeliveryAddress($addressUI);

                        if (!address.ID) {
                            isAddressAdded = true;
                        }

                        deliveryAddresses.push({ DeliveryAddress: address });
                    });

                    $.blockUI({ message: null });
                    $.ajax({
                            url: handlerUrl,
                            method: 'POST',
                            data: {
                                action: 'UpdateRegistrationInfo',
                                company: company,
                                customers: customers,
                                addresses: deliveryAddresses
                            }
                        })
                        .always(function() {
                            $.unblockUI();

                            if (isCustomerAdded) {
                                _onNewContactEditFinished(false);
                            }

                            if (isAddressAdded) {
                                _onNewDelivAddressEditFinished(false);
                            }
                        })
                        .done(function(result) {
                            if (_detectAndHandleRedirect(result)) {
                                return;
                            }

                            company = result.company;
                            _displayCompany();

                            $customerSections.each(function(index, customerSection) {
                                if (index < result.customers.length) {
                                    const customer = result.customers[index];
                                    customer.IsNewCustomer = false;
                                    const $customerUI = $(customerSection);
                                    $customerUI.data('customer', customer);
                                    _displayCustomer($customerUI, customer);

                                    if (regType === 'private' && !_showDeliveryAddressSection) {
                                        _displayDeliveryAddressDescriptionForPrivateUser($customerUI, result.addresses);
                                    }

                                    if (company && customer.UserID !== ctx.thisUserId) {
                                        $customerUI.find('.ButtonDeletecustomer').removeClass('hidden').removeAttr('hidden');
                                    }
                                }
                            });

                            if (_shouldShowContactTagify === true) {
                                const contacts = _getContactsFromContainers();
                                let newContactUserId = contacts && contacts.length ? contacts.pop().UserID : null;
                                _setVisibleContactContainer(newContactUserId);
                                _updateContactTagifyWhitelist(newContactUserId);
                            }

                            $deliveryAddressSections.each(function(index, deliveryAddressSection) {
                                if (index < result.addresses.length) {
                                    const address = result.addresses[index];
                                    const $addressUI = $(deliveryAddressSection);

                                    if (!address) {
                                        if (ctx.allowMultipleDelivAddresses) {
                                            $addressUI.remove();
                                        }
                                    } else {
                                        const initialAddress = deliveryAddresses[index];
                                        address.UserID = initialAddress.DeliveryAddress.UserID;

                                        $addressUI.data('deliveryAddress', address);
                                        _displayDeliveryAddress($addressUI, address);
                                        $addressUI.find('.ButtonDeletedeliveryaddress').show();
                                        $addressUI.find('.ButtonDefaultDeliveryAddress').show();
                                    }
                                }
                            });

                            if (_shouldShowDeliveryAddressTagify === true) {
                                if (isAddressAdded === true) {
                                    const newDeliveryAddressId = _getDeliveryAddressesFromContainers().pop().ID;
                                    _setVisibleDeliveryAddressContainer(newDeliveryAddressId);
                                    _updateDeliveryAddressesTagifyWhitelist(newDeliveryAddressId);
                                } else {
                                    _updateDeliveryAddressesTagifyWhitelist(null);
                                }
                            }

                            if (!_redirectToReturnUrlIfPresent(ctx.returnURL)) {
                                w.PubSub.publish('notification.success', ctx.messages.savedSuccessfully);
                                _clearErrorStates();
                            }
                        })
                        .fail(function(jqXHR, textStatus) {
                            if (typeof (jqXHR.responseJSON) === 'object' && jqXHR.responseJSON.Message) {
                                w.PubSub.publish('notification.error', jqXHR.responseJSON.Message);

                            } else {
                                w.PubSub.publish('notification.error', textStatus);
                            }
                        });
                });
            });
        }

        function _setupEmailInUseNotification() {
            if (ctx.showEmailInUseNotification) {
                $mainPanel.find('.ContactPersonEmailInput,.InvoiceEmailInput').on('change',
                    function() {
                        $.noty.closeAll();
                        const inputEmail = ($(this).val() || '').toLowerCase();
                        if (inputEmail) {
                            $.ajax({
                                    url: handlerUrl,
                                    method: 'GET',
                                    data: { action: 'exists', email: inputEmail }
                                })
                                .done(function(result) {
                                    const emailExists = result.exists;
                                    if (emailExists) {
                                        w.PubSub.publish('notification.warning',
                                            { text: ctx.messages.emailIsAlreadyInUse, timeout: 0, killer: true });
                                    }
                                });
                        }
                    });
            }
        };

        function _getSelectedRadioValue(radioButtons) {
            if (!radioButtons || radioButtons.length === 0) return false;
            let selectedValue = radioButtons.filter(':checked').val();
            return selectedValue;
        }

        function _selectRadioByValueMatch(radioButtons, value) {
            if (!radioButtons || radioButtons.length === 0) return false;

            radioButtons.each(function(index, radioButton) {
                if (radioButton.value === value.toString()) {
                    radioButton.checked = true;
                    return true;
                }
            });

            return false;
        }

        function _getNewsletterSubscirptionStatus($ui) {
            const { $checkbox, $radioButtons } = findNewsletterElements($ui);

            if($checkbox.length === 1) {
                return $checkbox.is(':checked')
            } else if ($radioButtons.length) {
                const $radioButtons = $ui.find('.js-receive-newsletter-radiobutton');
                return _getSelectedRadioValue($radioButtons);
            }

            return null;
        }

        function _setNewsletterSubscirptionStatus($ui, isSubscribed) {
            const subscribedValueToSet = (isSubscribed === true);           
            const { $checkbox, $radioButtons } = findNewsletterElements($ui);

            if($checkbox.length === 1) {
                $checkbox.prop('checked', subscribedValueToSet);
            } else if ($radioButtons.length) {
                if (isSubscribed === null) return false;
                const $radioButtons = $ui.find('.js-receive-newsletter-radiobutton');
                return _selectRadioByValueMatch($radioButtons, subscribedValueToSet);
            } else {
                console.warn('No newsletter subscription elements found.');
                return false;
            }
        }

        // Utility function to find newsletter subscription elements
        function findNewsletterElements($ui) {
            return {
                $checkbox: $ui.find('.js-contact-receive-newsletter, .js-company-receive-newsletter'),
                $radioButtons: $ui.find('.js-receive-newsletter-radiobutton')
            };
        }

        function _setupNewCustomer() {
            if (_isNewCustomer) {
                $mainPanel.find('.ExistingCustomerOnly').hide();
            } else {
                $mainPanel.find('.NewCustomerOnly').hide();
            }
        }

        function _setupContactFormMode() {
            if (_contactFormModeIsEnabled) {
                $mainPanel.find('.ContactFormModeHiddenRow').hide();
                $mainPanel.find('.DeliveryAddressesSectionContainer').hide();

                if (_useTabs === true) {
                    const els = _getTabsElements();
                    els.liTabDelivery.addClass('hidden').attr('hidden', true);
                    els.tabDelivery.addClass('hidden').attr('hidden', true);
                }
            }
        }

        function _clearErrorStates() {
            $mainPanel.find('.nav-tabs li').removeClass('has-required-fields');
        }

        $(function() {
            _setupShowNewsletterFlags();
            _setupDateOfBirthValidator();
            _setupRegistrationType();
            _setupCompanySection();

            _setupCustomerSection();
            _setupDeliveryAddressesSection();
            _setupRegisterButton();
            _setupSaveButton();

            _setupEmailInUseNotification();
            _setupNewCustomer();
            _setupContactFormMode();

            _setupContactAndDeliveryAddressTagify();
            _setupToolTip($mainPanel);
        });
    }
})(window, jQuery);